import { VersioningStatusEnum } from '@/enums/VersioningStatus';

export abstract class Model {
  id!: number;
  createdAt?: string;
  updatedAt?: string;

  constructor(model?: Partial<Model>) {
    this.id = model?.id ?? 0;
    this.createdAt = model?.createdAt ?? undefined;
    this.updatedAt = model?.updatedAt ?? undefined;
  }
}

export interface Ordenable {
  order: number;
}

export interface Versionable {
  version: number;
  status: VersioningStatusEnum;
}
export type Nullable<T> = T | null;
